import * as React from 'react';
import { classes, style } from 'typestyle';
import { center, flexRoot } from 'csstips';
import { px } from 'csx';
import { rebrand } from '../../../theme/color';
import { spacing } from '../../../theme/spacing';
import { borderRadius } from '../../../theme/border';
import { NestedCSSProperties } from 'typestyle/lib/types';
import { LicenceSchema } from '../../../types/schema';
import { ExternalLink } from '../atoms/icons/ExternalLink';

interface StatusFlagProps {
  licence: LicenceSchema;
}

const sharedFlagStyles: NestedCSSProperties = {
  borderRadius: borderRadius.SMALL,
  padding: `${spacing.XXSMALL} ${spacing.XSMALL}`,
  fontSize: px(12),
  width: 'fit-content',
};

const styles = {
  statusFlag: style(flexRoot, center, {
    marginBottom: spacing.XSMALL,
  }),
  readyToUse: style(sharedFlagStyles, {
    backgroundColor: rebrand.semantic.success[20].toHexString(),
    color: rebrand.semantic.success[100].toHexString(),
  }),
  used: style(sharedFlagStyles, {
    backgroundColor: rebrand.neutralOnDark[20].toHexString(),
    color: rebrand.contrast[40].toHexString(),
  }),
  icon: style({
    verticalAlign: 'middle',
    marginLeft: px(4),
  }),
};

export const StatusFlag: React.FC<StatusFlagProps> = ({ licence }) => {
  if (licence.used_at) {
    return (
      <div className={styles.statusFlag}>
        <div className={styles.used}>Used</div>
        {licence.youtube_video_claims.length > 0 && (
          <a
            target="_blank"
            rel="noreferrer"
            href={`https://www.youtube.com/watch?v=${licence.youtube_video_claims[0].youtube_video_id}`}
            data-test-youtube-video-link
            aria-label="Go to the YouTube video this license was used in"
          >
            <ExternalLink className={styles.icon} size={14} />
          </a>
        )}
      </div>
    );
  } else {
    return <div className={classes(styles.statusFlag, styles.readyToUse)}>Ready to use</div>;
  }
};
